import { Controller } from '@hotwired/stimulus';
import { useModal } from '../../js/stimulus_use/use-modal';

export default class extends Controller {
    static targets = ['paymentsMethodCheckBox'];

    connect() {
        this.selectedValues = [];
    }

    openModal() {
        const selected = [...document.querySelectorAll('#payment-methods-paragraph span')]
            .map(s => s.textContent.trim().toLowerCase());

        this.paymentsMethodCheckBoxTargets.forEach(checkbox => {
            const text = checkbox.closest('label').querySelector('.d-block').textContent.trim().toLowerCase();
            checkbox.checked = selected.includes(text);
        });

        $(this.element).modal('show');
    }

    onChange() {
        this.selectedValues = this.paymentsMethodCheckBoxTargets.map(checkbox => ({
            field: checkbox.id,
            value: checkbox.checked,
        }));
    }

    save(event) {
        event.preventDefault();

        const data = this.selectedValues;

        showPreloader();

        $.ajax({
            url: routes['app_profile_editpayment'],
            method: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            success: result => {
                if (result.status) {
                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            category: 'Account',
                            action: 'profile_payment_update | Success',
                            label: typeof GA_EVENT_LABEL !== 'undefined' ? GA_EVENT_LABEL : '',
                        },
                    });
                }
                addAlert('success', result.message);
                window.location.reload();
            },
            error: () => {
                dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        'category': 'Account',
                        'action': 'profile_payment_update | Failure',
                        'label': GA_EVENT_LABEL,
                    },
                });

                addAlert('danger', translations['profile.An unknown error occurred.']);
                hidePreloader();
            },
        });

    }
}
